export default {
    map:{
        InfoBase:"基本信息",
        Sensor:"传感器",
        Gateway:"网关",
        Display:"显示屏",
        Relay:"中继",
        back:"返回",
        refresh:"刷新",
        loadMapDataFailed:"加载地图数据失败",
        loadTrackFailed:"加载轨迹失败",
        getDeviceDetailFailed:"获取设备详情失败",
        getDetailFailed:"获取详情失败",
        details:"详情",
        headquarters:"总部",
        latitude:"纬度",
        longitude:"经度",
        moving:"行驶中",
        viewFloorPlan:"查看平面图",
        monitoringOverview:"监控概况",
        floorPlan:"楼层平面图",
        deviceView:"设备视图",
        assetView:"资产视图",
        floorPlanHint:"悬停设备标记可查看详情，点击设备可跳转历史曲线，双击图片可全屏查看（点击任意位置关闭）",
        temperatureSensor:"温湿度传感器",
        gasSensor:"气体传感器",
        doorMagnetic:"门磁",
        airSensor:"空气质量传感器",
        unknownDevice:"未知设备",
        vehicleTrace:"车辆轨迹",
        warning:"预警",
        offline:"离线",
        stopped:"停车",
        currentTemperature:"当前温度",
        averageSpeed:"平均速度",
        maxTemperature:"最高温度",
        minTemperature:"最低温度",
        tracePoints:"轨迹点数",
        drivingTimeline:"行驶时间线",
        temperatureTrend:"温度趋势",
        onlineDevices:"在线设备",
        warningDevices:"异常设备",
        dangerDevices:"离线设备",
        vehicles:"移动资产",
        recentEvents:"最近事件",
        noAlerts:"暂无告警",
        view_track:"查看轨迹",
        track_dialog_title:"运行轨迹",
        track_total_points:"轨迹点总数",
        track_avg_speed:"平均速度",
        track_max_speed:"最高速度",
        track_speed_color:"速度颜色",
        track_sensor_data:"传感器数据",
        track_collection_time:"采集时间",
        track_speed:"速度",
        temperature:"温度",
        humidity:"湿度",
        track_rendering_control:"轨迹渲染控制",
        point_size:"点大小",
        line_width:"线条宽度",
        speed_unit_mph:"km/h",
        speed_0_mph:"0 km/h",
        max:"最大"
    }
}
